import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import TdsLink from '@tds/core-link';

import Page from './page';
import { PaginationWrapper, PageWrapper } from './css';

const MAX_VISIBLE_PAGES = 5;

const getPages = (step, total) => {
  const pages = [];
  let page = 1;
  let index = 1;

  while (index <= total) {
    pages.push(page);
    page += 1;
    index += step;
  }

  return { pages, totalPages: pages.length };
};

const getUrl = (url, page) => `${url}${url ? '&' : '?'}&page=${page}`;

const isPageVisible = (page, currentPage, totalPages, maxVisiblePages) => {
  const leftAmount = 1;
  const rightAmount = maxVisiblePages - 2;

  return (
    totalPages <= maxVisiblePages ||
    (page < currentPage + rightAmount && page > currentPage - rightAmount) ||
    ((currentPage === leftAmount || currentPage === leftAmount + 1) &&
      page <= maxVisiblePages) ||
    (currentPage === totalPages && page >= totalPages - maxVisiblePages) ||
    (currentPage === totalPages - 1 && page > totalPages - maxVisiblePages)
  );
};

const Pagination = ({ totalRecords, step, currentPage, url }) => {
  const { pages, totalPages } = getPages(step, totalRecords);
  const isVisible = totalRecords > currentPage * step || currentPage > 1;

  return (
    <PaginationWrapper>
      {currentPage > 1 && MAX_VISIBLE_PAGES < totalPages && (
        <TdsLink to={getUrl(url, 1)} reactRouterLinkComponent={RouterLink}>
          <PageWrapper>{'<<'}</PageWrapper>
        </TdsLink>
      )}
      {isVisible &&
        pages.map(
          page =>
            isPageVisible(page, currentPage, totalPages, MAX_VISIBLE_PAGES) && (
              <Page
                key={`page${page}`}
                page={page}
                isSelected={page === currentPage}
                url={getUrl(url, page)}
              />
            )
        )}
      {currentPage < totalPages && MAX_VISIBLE_PAGES < totalPages && (
        <TdsLink
          to={getUrl(url, totalPages)}
          reactRouterLinkComponent={RouterLink}
        >
          <PageWrapper>{'>>'}</PageWrapper>
        </TdsLink>
      )}
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  totalRecords: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired
};

export default Pagination;
